// extracted by mini-css-extract-plugin
export default {"PrivacyPage":"PrivacyPage_PrivacyPage__6L2t5"};